const mainNoticeStore = {
  namespaced: true,
  state() {
    return {
      noticeData: [],
      urgentData: [],
    };
  },
  getters: {
    isNoticeVisible(state) {
      return state.noticeData.length > 0;
    },
    isUrgentVisible(state) {
      return state.urgentData.length > 0;
    },
  },
  mutations: {
    setNoticeData(state, data) {
      state.noticeData = data;
    },
    setUrgentData(state, data) {
      state.urgentData = data;
    },
  },
  actions: {
    async getNotice({ commit }) {
      const {
        data: { data: resData },
      } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/notice`);

      commit('setNoticeData', resData);

      return;
    },
    async getUrgentNotice({ commit }) {
      const {
        data: { data: resData },
      } = await this._vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/notice/urgent`);

      commit('setUrgentData', resData);

      return;
    },
  },
};

export default mainNoticeStore;
